const header = [
    { text: "Nome", value: "physicalpeople.name" },
    { text: "CPF", value: "physicalpeople.cpf" },
    { text: "Identidade", value: "physicalpeople.idCard" },
    { text: "Data de Nascimento", value: "physicalpeople.dateOfBirth" },
    { text: "Nacionalidade", value: "physicalpeople.nacionality" },
    { text: "Naturalidade", value: "physicalpeople.naturality" },
    { text: "Estado Civil", value: "physicalpeople.civilStatus" },
    { text: "Ações", value: "actions" },
];

export { header };

